import styled from '@emotion/styled';

import { addComma } from '../../../services';
import COLOR from '../../../constant/colorset';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const PriceTag = styled.span<{ lineThrough?: boolean; }>`
  text-decoration: ${({ lineThrough }) => lineThrough ? 'line-through' : ''};
  color: ${({ lineThrough }) => lineThrough ? COLOR.kurlyGray400 : COLOR.kurlyGray800};
`;

const DiscountRate = styled.span`
  color: ${COLOR.pointText}
`;

interface Props {
  price: number;
  discount?: {
    price: number;
    rate: number;
  };
  className?: string;
  isMultiplePrice?: boolean;
}

export default function ProductCardPrice({
  price, discount, className, isMultiplePrice,
}: Props) {
  const priceText = (value: number) => {
    const text = `${addComma(value)} 원`;

    if (isMultiplePrice) {
      return text + '~';
    }

    return text;
  };

  return (
    <Container className={className}>
      {discount &&
        <div>
          <DiscountRate className="discount-rate">{discount.rate}%</DiscountRate>
          <PriceTag className="sales-price">
            {priceText(discount.price)}
          </PriceTag>
        </div>
      }
      <PriceTag className={discount ? 'dimmed-price' : 'sales-price'}>
        {priceText(price)}
      </PriceTag>
    </Container>
  );
}
